/**
 * ReadOnlyNotice — explains WHY write controls are disabled for a read-only
 * (viewer / client) account. Security I0 S5: the server refuses AI runs, hiring,
 * team launches, trigger runs, delegation… to non-writer roles with 403, so the
 * UI disables those controls and states the reason once per surface.
 */
import { READ_ONLY_HINT, useRoles } from '@/routes/settings/useRoles';

export function ReadOnlyNotice({ what }: { what?: string }) {
  const { isWriter } = useRoles();
  if (isWriter) return null;
  return (
    <div
      role="note"
      data-testid="read-only-notice"
      className="rounded-token border border-border bg-surface-2 px-3 py-2 text-sm text-muted"
    >
      {READ_ONLY_HINT}
      {what ? ` : ${what}.` : '.'}
    </div>
  );
}
